const rows = [
  { label: "Processing Speed", us: "24–72 Hours", agency: "Emergency walk-in (limited)" },
  { label: "Appointment Required", us: "No — we handle submission", agency: "Yes — slots fill within minutes" },
  { label: "Drive from Lee's Summit", us: "None — ship documents to us", agency: "25 min each way Downtown KC" },
  { label: "Document Review", us: "Professional review before submission", agency: "Rejected applications returned" },
  { label: "Cost vs. FedEx/Staples", us: "30–100% less (best price guarantee)", agency: "N/A (direct government)" },
  { label: "Hours", us: "Mon–Fri, 8AM–6PM EST", agency: "Limited emergency hours" },
  { label: "Case Tracking", us: "Live updates provided", agency: "No proactive updates" },
];

export default function LeeSummitComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Comparison</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Kansas City Regional Agency
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Lee&apos;s Summit residents can reach the KC agency in 25 minutes — but emergency appointment slots are scarce and the risk of rejection is real. Here&apos;s why our reserved courier service is the smarter choice.
          </p>
        </div>

        <div className="bg-amber-50 border border-[#F6C344]/40 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <h3 className="font-bold text-base text-[#1A365D] mb-1">Passport Agency Appointment Not Available?</h3>
              <p className="text-sm text-gray-600">Don't let a booked-out agency appointment block your travel plans. We bypass the agency bottleneck with reserved daily courier slots — faster and no appointment roulette.</p>
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="grid grid-cols-3 bg-[#1A365D] text-white text-sm font-bold">
            <div className="p-4 text-left">Category</div>
            <div className="p-4 text-center border-l border-white/10">Fast Passport Center</div>
            <div className="p-4 text-center border-l border-white/10">KC Regional Agency</div>
          </div>
          {rows.map((row, i) => (
            <div
              key={i}
              className={`grid grid-cols-3 text-sm ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}
            >
              <div className="p-4 text-gray-700 font-medium">{row.label}</div>
              <div className="p-4 text-center border-l border-gray-100">
                <span className="flex items-center justify-center gap-1.5 text-[#1A365D] font-semibold">
                  <i className="ri-check-line text-[#F6C344]"></i> {row.us}
                </span>
              </div>
              <div className="p-4 text-center border-l border-gray-100 text-gray-400">{row.agency}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}